// export const API_SERVER = "";
export const API_SERVER = "http://local.dinodev.hu";
// export const API_SERVER = "https://api.dinodev.hu";
